import { Routes } from '@angular/router';
import { mobileAuthChildGuard, mobileAuthGuard, mobileGuestGuard } from './core/mobile-auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'app/visitors',
    pathMatch: 'full',
  },
  {
    path: 'auth/login',
    canActivate: [mobileGuestGuard],
    loadComponent: () => import('./auth/mobile-login.page').then((m) => m.MobileLoginPage),
  },
  {
    path: 'app',
    canActivate: [mobileAuthGuard],
    canActivateChild: [mobileAuthChildGuard],
    loadComponent: () => import('./shell/admin-mobile-shell.page').then((m) => m.AdminMobileShellPage),
    children: [
      {
        path: '',
        redirectTo: 'visitors',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        redirectTo: 'visitors',
        pathMatch: 'full',
      },
      {
        path: 'visitors',
        loadComponent: () => import('./visitors/mobile-visitors.page').then((m) => m.MobileVisitorsPage),
      },
      {
        path: 'profile',
        loadComponent: () => import('./profile/mobile-profile.page').then((m) => m.MobileProfilePage),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'app/visitors',
  },
];
